import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing a view for filtering taxable earnings.
 * @extends JetView
 */
export default class FilterTaxableEarningsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Label for the input
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            margin: 15,
                            css: 'on-row',
                            height: document.body.offsetWidth < 500 ? 150 : 0, // Conditional height
                            cols: [
                                {
                                    view: 'radio', // Radio buttons for user type selection
                                    name: 'TypeUser',
                                    label: _('Tipo de Usuario'), // Label for the radio group
                                    labelPosition: 'top',
                                    value: 0, // Default selected value
                                    options: [
                                        { id: 0, value: _('Todos') }, // Option for all users
                                        {
                                            id: 1,
                                            value: "<span class='icon-players'></span> ", // Option for players
                                        },
                                        {
                                            id: 2,
                                            value: "<span class='icon-shop'></span>", // Option for shops
                                        },
                                    ],
                                },
                                { id: 'grav2', gravity: 1 }, // Gravity for layout
                            ],
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 360 : 0, // Conditional height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing inputs
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Button to clear the form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form inputs
                            },
                        },
                        {
                            view: 'button', // Button to submit the form
                            value: _('Consultar'),
                            hotkey: 'enter', // Shortcut key for submission
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                                    }
                                }
                                this.app.callEvent('taxableEarnings:filter', [
                                    filterdata, // Trigger filter event with form data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide gravity element on small screens
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Datepicker if typeDate is not 2
                $$('Datepicker').show();
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if typeDate is 2
                    $$('Datepicker').hide();
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration after rendering
        });
    }
}

// FILE DOCUMENTED
